import { action } from '@ember/object';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type { Args as DataManagerGridItemArgs } from 'webapp/components/data-manager/grid-item';
import DataManagerGridItemComponent from 'webapp/components/data-manager/grid-item';

export default class MetricLibrarySourceGridItemComponent extends DataManagerGridItemComponent<DataManagerGridItemArgs> {
	@service('navigation') declare navigationService: Service.Navigation;

	override get isOverlayHidden(): boolean {
		return true;
	}

	@action
	override triggerClick(): void {
		this.navigationService.transitionToRoute(
			'metric-library.source.specific',
			this.args.model.key,
			'',
		);
	}
}
